import env from "../../../root/env.js";
import { post } from "../../../root/modules/http/post.js";
import { loggingContexts } from "../../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../../root/modules/logs/log.js";
import { connectToPubNub } from "../../functions/connect-to-pubnub.js";
import { saveDataOnActivation } from "../../functions/save-data-on-activation.js";
import { mainLoop } from "../../modules/main/main-loop.js";

const activateLog = log(loggingContexts.activate);

const apiURL = env.VITE_API_URL;
const mainLoopInterval = env.VITE_MAIN_LOOP_INTERVAL;

export async function activate({ productKey }) {
  const {
    computerName,
    desktopVersion,
    machineId,
    osArch,
    osMACs,
    osPlatform,
    osRelease,
    osType,
    osVersion,
    webVersion,
  } = this;

  try {
    const response = await post(`${apiURL}/v4/alerters/activate`, {
      json: {
        computerName,
        machineId,
        osArch,
        osMACs,
        osPlatform,
        osRelease,
        osType,
        osVersion,
        productKey,
        version: { desktop: desktopVersion, web: webVersion },
      },
    }).json();

    if (response) {
      const {
        activatedAt,
        browserCommand,
        channel,
        emsAgency,
        group,
        hospital,
        name,
        publishKey,
        ssoProvider,
        ssoSubdomain,
        subscribeKey,
      } = response;

      if (!hospital && !emsAgency) {
        throw new Error(
          "Trying to activate an Alerter without an associated agency or hospital."
        );
      }

      const showOptions = response.features?.find?.(
        (feature) => feature.name === "showOptions"
      )?.enabled;

      const silenceButton = response.features?.find?.(
        (feature) => feature.name === "silenceButton"
      )?.enabled;

      const acknowledgeButton = response.features?.find?.(
        (feature) => feature.name === "acknowledgeButton"
      )?.enabled;

      saveDataOnActivation(
        {
          acknowledgeButton,
          activatedAt,
          browserCommand,
          channel,
          group,
          name,
          productKey,
          publishKey,
          showOptions,
          silenceButton,
          ssoProvider,
          ssoSubdomain,
          subscribeKey,
          ...(hospital && { hospitalId: hospital.id }),
          ...(emsAgency && { emsAgencyId: emsAgency.id }),
        },
        this
      );

      connectToPubNub({ channel, productKey });

      await mainLoop({ timeout: mainLoopInterval });

      await window.api?.writeConfiguration?.({
        configuration: { activatedAt, productKey },
      });
    }
  } catch (error) {
    if (error.response) {
      const response = await error.response.json();

      activateLog.info("activation failed (HTTP error)", response.message);

      window.alert(response.message);
    } else {
      activateLog.info("activation failed (unknown error)", error.message);

      window.alert(error.message);
    }
  }
}
